// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4f3e440a] .form-control:focus{box-shadow:none !important}[data-v-4f3e440a] .modal-body{padding:20px !important}", ""]);
// Exports
module.exports = exports;
